"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyAvatarGroup = void 0;

const react_1 = __importDefault(require("react"));

const colors = __importStar(require("@mui/material/colors"));

const md5_1 = __importDefault(require("md5"));

const SskyAvatar_1 = __importDefault(require("../SskyAvatar")); // todo - This is a copy from future implementation of material-ui. Once possible, use the one from material-ui


const material_1 = require("@mui/material");

const COLORS = Object.values(colors).map(color => color[500]);

const colorByHash = contentMd5 => {
  return COLORS[parseInt(contentMd5.slice(0, 3), 16) % COLORS.length];
};

const SskyAvatarGroup = props => {
  var _a, _b;

  const {
    avatarData,
    innerClassName,
    extraAvatarsClassName,
    extraAvatarsOnClick
  } = props;
  const spacing = (_a = props.spacing) !== null && _a !== void 0 ? _a : "medium";
  const max = (_b = props.max) !== null && _b !== void 0 ? _b : 4;
  const allAvatarNames = avatarData.map(avatarData => avatarData.content);
  const extraAvatars = avatarData.length > max ? avatarData.slice(max - 1) : [];
  const avatarsToShow = avatarData.slice(0, avatarData.length - extraAvatars.length);
  const extraAvatarsToolTip = react_1.default.createElement(react_1.default.Fragment, null, extraAvatars.map(s => react_1.default.createElement(react_1.default.Fragment, null, s.content, react_1.default.createElement("br", null))));
  return react_1.default.createElement(material_1.Box, {
    sx: {
      position: "relative",
      height: 40
    }
  }, react_1.default.createElement(material_1.AvatarGroup, {
    max: max,
    spacing: spacing
  }, avatarsToShow.map(avatar => {
    const {
      content,
      backgroundColor,
      onClick
    } = avatar;
    const contentMd5 = (0, md5_1.default)(content);
    const avatarBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : colorByHash(contentMd5);
    return react_1.default.createElement(SskyAvatar_1.default, {
      key: content,
      className: innerClassName,
      content: content,
      onClick: e => onClick(e, content),
      contentMd5: contentMd5,
      backgroundColor: avatarBackgroundColor,
      tooltipPlacement: "bottom"
    });
  }), extraAvatars.length > 0 ? react_1.default.createElement(SskyAvatar_1.default, {
    key: `extra-avatars-${extraAvatars.length}`,
    className: extraAvatarsClassName,
    content: `+${extraAvatars.length}`,
    onClick: e => extraAvatarsOnClick(e, allAvatarNames),
    tooltipContent: extraAvatarsToolTip,
    tooltipPlacement: "bottom",
    isExtraAvatar: true
  }) : null));
};

exports.SskyAvatarGroup = SskyAvatarGroup;
exports.default = react_1.default.memo(SskyAvatarGroup);